<section class="text-section">
    <div class="container">
        <h1 class="intro-title">Privacy <span>Policy</span></h1>
        <div class="text">We are delighted that you have shown interest in our Website, located at, (the «Website»),
            which is Realis (the «Company»). Data protection is of a particularly high priority for us. The use of our
            Website is possible without any indication of personal data; however, if you want to use services via our
            Website, processing of personal data could become necessary. If the processing of personal data is necessary
            and there is no statutory basis for such processing, we generally obtain consent from you. The processing of
            personal data, such as the name, address, e-mail address, or telephone number of a data subject shall always
            be in line with the EU General Data Protection Regulation (GDPR), and in accordance with the
            country-specific data protection regulations applicable to the Company. By means of this data protection
            declaration, our Company would like to inform the general public of the nature, scope, and purpose of the
            personal data we collect, use and process. Furthermore, data subjects are informed, by means of this data
            protection declaration, of the rights to which they are entitled. As the controller, we have implemented
            numerous technical and organizational measures to ensure the most complete protection of personal data
            processed through this Website. However, Internet-based data transmissions may in principle have security
            gaps, so absolute protection may not be guaranteed. For this reason, every data subject is free to transfer
            personal data to us via alternative means, e.g. by telephone.
        </div>
        <h2 class="subtitle">I. Definitions</h2>
        <div class="text">This Privacy Policy of the Company (the «Privacy Policy») is based on the terms used by the
            European legislator for the adoption of the General Data Protection Regulation («GDPR»). Our Privacy Policy
            should be legible and understandable for the general public, as well as our contributors and business
            partners. To ensure this, we would like to first explain the terminology used. <br><br>In this Privacy
            Policy, we use, inter alia, the following terms:
        </div>
        <h3 class="subtitle">a) Personal data</h3>
        <div class="text">Personal data means any information relating to an identified or identifiable natural person
            («data subject»). An identifiable natural person is one who can be identified, directly or indirectly, in
            particular by reference to an identifier such as a name, an identification number, location data, an online
            identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic,
            cultural or social identity of that natural person.
        </div>
        <h3 class="subtitle">b) Data</h3>
        <div class="text">Data subject is any identified or identifiable natural person, whose personal data is
            processed by the controller responsible for the processing.
        </div>
        <h3 class="subtitle">c) Processing</h3>
        <div class="text">Processing is any operation or set of operations which is performed on personal data or on
            sets of personal data, whether or not by automated means, such as collection, recording, organization,
            structuring, storage, adaptation or alteration, retrieval, consultation, use, disclosure by transmission,
            dissemination or otherwise making available, alignment or combination, restriction, erasure or destruction.
        </div>
        <h3 class="subtitle">d) Restriction of processing</h3>
        <div class="text">Restriction of processing is the marking of stored personal data with the aim of limiting
            their processing in the future.
        </div>
        <h3 class="subtitle">e) Profiling</h3>
        <div class="text">Profiling means any form of automated processing of personal data consisting of the use of
            personal data to evaluate certain personal aspects relating to a natural person, in particular to analyze or
            predict aspects concerning that natural person’s performance at work, economic situation, health, personal
            preferences, interests, reliability, behavior, location or movements.
        </div>
        <h3 class="subtitle">f) Pseudonymisation</h3>
        <div class="text">Pseudonymisation is the processing of personal data in such a manner that the personal data
            can no longer be attributed to a specific data subject without the use of additional information, provided
            that such additional information is kept separately and is subject to technical and organizational measures
            to ensure that the personal data are not attributed to an identified or identifiable natural person.
        </div>
        <h3 class="subtitle">g) Controller or controller responsible for the processing</h3>
        <div class="text">Controller or controller responsible for the processing is the natural or legal person, public
            authority, agency or other body which, alone or jointly with others, determines the purposes and means of
            the processing of personal data; where the purposes and means of such processing are determined by Union or
            Member State law, the controller or the specific criteria for its nomination may be provided for by Union or
            Member State law.
        </div>
        <h3 class="subtitle">h) Processor</h3>
        <div class="text">Processor is a natural or legal person, public authority, agency or other body which processes
            personal data on behalf of the controller.
        </div>
        <h3 class="subtitle">i) Recipient</h3>
        <div class="text">Recipient is a natural or legal person, public authority, agency or another body, to which the
            personal data are disclosed, whether a third party or not. However, public authorities which may receive
            personal data in the framework of a particular inquiry in accordance with Union or Member State law shall
            not be regarded as recipients; the processing of those data by those public authorities shall be in
            compliance with the applicable data protection rules according to the purposes of the processing.
        </div>
        <h3 class="subtitle">j) Third party</h3>
        <div class="text">Third party is a natural or legal person, public authority, agency or body other than the data
            subject, controller, processor and persons who, under the direct authority of the controller or processor,
            are authorized to process personal data.
        </div>
        <h3 class="subtitle">k) Consent</h3>
        <div class="text">Consent of the data subject is any freely given, specific, informed and unambiguous indication
            of the data subject’s wishes by which he or she, by a statement or by a clear affirmative action, signifies
            agreement to the processing of personal data relating to him or her.
        </div>
        <h2 class="subtitle">II. Cookies</h2>
        <div class="text">This Website uses cookies. Through the use of cookies, we can provide you more userfriendly
            services that would not be possible without the cookie setting.<br><br>Cookies are text files that are
            stored in a computer system via an Internet browser. Many cookies contain a so-called cookie ID. A cookie ID
            is a unique identifier of the cookie. It consists of a character string through which Internet pages and
            servers can be assigned to the specific Internet browser in which the cookie was stored. This allows visited
            Internet sites and servers to differentiate the individual browser of the data subject from other Internet
            browsers that contain other cookies. A specific Internet browser can be recognized and identified using the
            unique cookie ID.<br><br>By means of a cookie, the information and offers on our website can be optimized
            with the user in mind. Cookies allow us, as previously mentioned, to recognize our website users. The
            purpose of this recognition is to make it easier for users to utilize our website. The website user that
            uses cookies, e.g. does not have to enter access data each time the website is accessed, because this is
            taken over by the website, and the cookie is thus stored on the user’s computer system.<br><br>The data
            subject may, at any time, prevent the setting of cookies through our website by means of a corresponding
            setting of the Internet browser used, and may thus permanently deny the setting of cookies. Furthermore,
            already set cookies may be deleted at any time via an Internet browser or other software programs. This is
            possible in all popular Internet browsers. If the data subject deactivates the setting of cookies in the
            Internet browser used, not all functions of our website may be entirely usable.
        </div>
        <h2 class="subtitle">III. Collection of general data and information</h2>
        <div class="text">This Website collects a series of general data and information when you or automated system
            calls up the Website. This general data and information are stored in the server log files. Collected may be
            (1) the browser types and versions used, (2) the operating system used by the accessing system, (3) the
            website from which an accessing system reaches our website (so-called referrers), (4) the sub-websites, (5)
            the date and time of access to the Website, (6) an Internet protocol address (IP address), (7) the Internet
            service provider of the accessing system, and (8) any other similar data and information that may be used in
            the event of attacks on our information technology systems.<br><br>When using these general data and
            information, the Company does not draw any conclusions about you. Rather, this information is needed to (1)
            provide our products and services,including this Site, and improve them over time, (2) deliver the content
            of our Website correctly, (2) optimize the content of our Website as well as its advertisement, (3) ensure
            the long-term viability of our information technology systems and website technology, (4) personalize and
            manage our relationship with you, including introducing you to products or services that may be of interest
            to you, (5) investigate, respond to, and manage inquiries or events, and (6) provide law enforcement
            authorities with the information necessary for criminal prosecution in case of a cyber-attack. Therefore,
            the Company analyses anonymously collected data and information statistically, with the aim of increasing
            the data protection and data security of our enterprise, and to ensure an optimal level of protection for
            the personal data we process. The anonymous data of the server log files are stored separately from all
            personal data provided by a data subject.
        </div>
        <h2 class="subtitle">IV. Registration on the Website</h2>
        <div class="text">You have the possibility to register on the Website with the indication of personal data.
            Which personal data are transmitted to the controller is determined by the respective input mask used for
            the registration. The personal data entered by the data subject are collected and stored exclusively for
            internal use by the controller, and for his own purposes. The controller may request transfer to one or more
            processors that also uses personal data for an internal purpose which is attributable to the controller.
            <br><br>By registering on the Website, the IP address, date, and time of the registration are also stored.
            The storage of this data is necessary to secure the Company as controller. This data is not passed on to
            third parties unless there is a statutory obligation to pass on the data, or if the transfer serves the aim
            of criminal prosecution.<br><br>The Company provides information upon request to you as to what personal
            data are stored about you. Also, we correct or erase personal data at the request or indication of you,
            insofar as there are no statutory storage obligations. The Data Protection Officer (as indicated in
            paragraph I.c) is available to you in this respect as contact person.
        </div>
        <h2 class="subtitle">V. Subscription to our newsletter</h2>
        <div class="text">On the Website, users are given the opportunity to subscribe to our newsletter. The input mask
            used for this purpose determines what personal data are transmitted, as well as when the newsletter is
            ordered from the controller.<br>The Company informs its customers and business partners regularly by means
            of a newsletter about enterprise offers. The Company’s newsletter may only be received by you if (1) you
            have a valid e-mail address and (2) you register for the newsletter shipping. A confirmation e-mail will be
            sent to the e-mail address registered by you for the first time for newsletter shipping, for legal reasons,
            in the double opt-in procedure. This confirmation e-mail is used to prove whether the owner of the e-mail
            address as the data subject is authorized to receive the newsletter.<br><br>During the registration for the
            newsletter, we also store the IP address of the computer system assigned by the Internet service provider
            (ISP) and used by the data subject at the time of the registration, as well as the date and time of the
            registration. The collection of this data is necessary in order to understand the (possible) misuse of the
            e-mail address of a data subject at a later date, and it therefore serves the aim of the legal protection of
            the controller.<br><br>The personal data collected as part of a registration for the newsletter will only be
            used to send our newsletter. In addition, subscribers to the newsletter may be informed by e-mail, as long
            as this is necessary for the operation of the newsletter service or a registration in question, as this
            could be the case in the event of modifications to the newsletter offer, or in the event of a change in
            technical circumstances. There will be no transfer of personal data collected by the newsletter service to
            third parties. The subscription to our newsletter may be terminated by you at any time. The consent to the
            storage of personal data, which you have given for shipping the newsletter, may be revoked at any time. For
            the purpose of revocation of consent, a corresponding link is found in each newsletter.
        </div>
        <h2 class="subtitle">VI. Contact possibility via the website</h2>
        <div class="text">The Website contains information that enables a quick electronic contact to our Company, as
            well as direct communication with us, which also includes a general address of the so called electronic mail
            (e-mail address). If you contact the Company by e-mail or via a contact form, the personal data transmitted
            are automatically stored. Such personal data transmitted on a voluntary basis by a data subject to the data
            controller are stored for the purpose of processing or contacting the data subject. There is no transfer of
            this personal data to third parties.
        </div>
        <h2 class="subtitle">VII. Routine erasure and blocking of personal data</h2>
        <div class="text">The Company processes and stores the personal data of the data subjects only for the period
            necessary to achieve the purpose of storage, or as far as this is granted by the European legislator or
            other legislators in laws or regulations to which the Company may be subject to.<br><br>If the storage
            purpose is not applicable, or if a storage period prescribed by the European legislator or another competent
            legislator expires, the personal data are routinely blocked or erased in accordance with legal requirements.
        </div>
        <h2 class="subtitle">VIII. Rights of the data subject</h2>
        <h3 class="subtitle">a) Right of confirmation</h3>
        <div class="text">You have the right to obtain from the Company the confirmation as to whether or not personal
            data concerning you are being processed. If you wish to avail yourself of this right of confirmation, you
            may, at any time, contact the Data Protection Officer (see paragraph I.c).
        </div>
        <h3 class="subtitle">b) Right of access</h3>
        <div class="text">You have the right to obtain from the Company free information about your personal data stored
            at any time and a copy of this information (including the purpose of processing, categories of personal data
            concerned, storage period, and more). Furthermore, you have a right to obtain information as to whether
            personal data are transferred to a third country or to an international organization. If this is the case,
            you have the right to be informed of the appropriate safeguards relating to the transfer. If you wish to
            avail yourself of this right of access, you may at any time contact the Data Protection Officer (see
            paragraph I.c).
        </div>
        <h3 class="subtitle">c) Right to rectification</h3>
        <div class="text">You have the right to obtain from the Company without undue delay the rectification of
            inaccurate personal data concerning you. Taking into account the purposes of the processing, you have the
            right to have incomplete personal data completed, including by means of providing a supplementary statement.
            If you wish to exercise this right to rectification, you may contact the Data Protection Officer (see
            paragraph I.c).
        </div>
        <h3 class="subtitle">d) Right to erasure (Right to be forgotten)</h3>
        <div class="text">You have the right to obtain from the Company the erasure of personal data concerning you with
            undue delay, and the Company has the obligation to erase personal data without undue delay, as long as the
            processing is no longer necessary. You may at any time contact the Data Protection Officer. The Data
            Protection Officer shall promptly ensure that the erasure request is complied with immediately.
        </div>
        <h3 class="subtitle">e) Right of restriction of processing</h3>
        <div class="text">You have the right to obtain from the Company restriction of processing if the processing is
            unlawful, if you contest the accuracy of your personal data or your personal data is no longer needed by the
            Company. If you wish to request the restriction of the processing of personal data stored by the Company,
            you may at any time contact the Data Protection Officer (see paragraph I.c).
        </div>
        <h3 class="subtitle">f) Right to data portability</h3>
        <div class="text">You have the right to receive from the Company, the personal data concerning you, in a
            structured, commonly used and machine-readable format. You have the right to transmit those data to another
            controller without hindrance from the Company, as long as the processing is based on consent pursuant to
            point (a) of Article 6(1) of the GDPR or point (a) of Article 9(2) of the GDPR, or on a contract pursuant to
            point (b) of Article 6(1) of the GDPR, and the processing is carried out by automated means, as long as the
            processing is not necessary for the performance of a task carried out in the public interest or in the
            exercise of official authority vested in the controller.
        </div>
        <h3 class="subtitle">g) Automated individual decision-making, including profiling</h3>
        <div class="text">Each data subject shall have the right granted by the European legislator not to be subject to
            a decision based solely on automated processing, including profiling, which produces legal effects
            concerning him or her, or similarly significantly affects him or her, as long as the decision (1) is not is
            necessary for entering into, or the performance of, a contract between the data subject and a data
            controller, or (2) is not authorized by Union or Member State law to which the controller is subject and
            which also lays down suitable measures to safeguard the data subject’s rights and freedoms and legitimate
            interests, or (3) is not based on the data subject’s explicit consent. If the decision (1) is necessary for
            entering into, or the performance of, a contract between the data subject and a data controller, or (2) it
            is based on the data subject’s explicit consent, the Company shall implement suitable measures to safeguard
            the data subject’s rights and freedoms and legitimate interests, at least the right to obtain human
            intervention on the part of the controller, to express his or her point of view and contest the
            decision.<br><br>If the data subject wishes to exercise the rights concerning automated individual decision
            making, he or she may at any time directly contact our Data Protection Officer.
        </div>
        <h2 class="subtitle">IX. Period for which the personal data will be stored</h2>
        <div class="text">The criteria used to determine the period of storage of personal data is the respective
            statutory retention period. After expiration of that period, the corresponding data is routinely deleted, as
            long as it is no longer necessary for the fulfillment of the contract or the initiation of a contract.
        </div>
        <h2 class="subtitle">Х. Disclaimer for the possible loss of funds</h2>
        <div class="text">LIS Token is not an investment tool or a means of earning money. By deciding to purchase, you
            take responsibility for the possible loss of funds.<br><br>We do not guarantee any profits. It is up to you
            to assess the risks and decide what to do with your LIS.<br><br>First of all, all Realis products are
            interesting games, and we do not guarantee your income in them.
        </div>
        <h2 class="subtitle">ХI. Advertising</h2>
        <div class="text">Our game may feature third-party advertisements delivered by ad networks and/or exchange
            services. These entities may use cookies, web beacons, or similar technologies to collect information about
            your interactions with the advertisements. This information may be used to provide you with more relevant
            advertisements in the future.
        </div>
        <h3 class="subtitle">a) Opting Out of Advertising</h3>
        <div class="text">You will only watch ads in our games if you want to get a free bonus and click the
            corresponding button to do this. If you want to opt out of watching ads, please just do not click on the
            free ad bonus.
        </div>
        <h3 class="subtitle">b) Changes to this Section</h3>
        <div class="text">We may update this Advertising section of our Privacy Policy from time to time. Please review
            this section periodically for any changes. Your continued use of our game after any modifications to this
            section will be deemed as acceptance of the updated terms.
        </div>
    </div>
</section>

<style>
    .text-section {
        padding: 125px 0 0;
        position: relative;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        color: white;
        margin: 0 0 40px;
        line-height: 90px;
        text-transform: uppercase;
        text-align: center;
    }

    .intro-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .text {
        font-size: 18px;
        color: white;
        line-height: 1.4;
        margin-bottom: 80px;
        text-align: justify;
    }

    .subtitle {
        font-size: 26px;
        color: white;
        margin: 20px 0;
        line-height: 1.4;
    }

    h3.subtitle {
        font-size: 22px;
    }

    @media (max-width: 992px) {
        .intro-title {
            font-size: 44px;
        }

        .text {
            margin-bottom: 60px;
        }
    }

    @media (max-width: 767px) {
        .text-section {
            padding: 80px 0 0;
        }

        .intro-title {
            font-size: 30px;
            margin-bottom: 10px;
        }

        .text {
            font-size: 14px;
            margin-bottom: 30px;
        }

        .subtitle {
            font-size: 24px;
            margin: 10px 0;
        }

        .text + h3.subtitle {
            font-size: 20px;
        }
    }
</style>
